<template lang="pug">
.search-student
  pulldown-select.search-student__action(v-model='selectedGrade', :selectOptions='gradeSelectOptions')
  textbox-search.search-student__action-input(v-model='fullNameValue', :placeholder='fullNamePlaceholder')
  textbox-search.search-student__action-input(
    v-if='isAdmin',
    v-model='academyNameValue',
    :placeholder='academyNamePlaceholder'
  )
  textbox-search.search-student__action-input-large(
    v-if='isAcademy || isAdmin',
    v-model='branchNameValue',
    :placeholder='branchNamePlaceholder'
  )
  textbox-search.search-student__action-input(v-model='statusValue', :placeholder='statusPlaceholder')
  button-search.search-student__action(@click='searchEvent')
    slot(name='searchButtonText')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TextboxSearch from '@/components/molecules/manager/TextboxSearch.vue'
import PulldownSelect from '@/components/molecules/manager/PulldownSelect.vue'
import ButtonSearch from '@/components/molecules/manager/ButtonSearch.vue'
import { UserRoles } from '@/const/UserRoles'
import { InputItem } from '@/models/inputItem'

/**
 * 生徒の絞り込み
 */
@Component({
  components: {
    TextboxSearch,
    PulldownSelect,
    ButtonSearch,
  },
})
export default class SearchStudent extends Vue {
  // 学年選択オプション
  @Prop()
  gradeSelectOptions!: InputItem[]

  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // 学年選択値
  @Prop()
  gradeValue!: string

  // 氏名
  @Prop()
  fullName!: string

  //  塾名（ユーザ権限がシステム管理者の場合のみ設定）
  @Prop()
  academyName?: string

  // 教室名(ユーザ権限がシステム管理者、塾管理者の場合のみ設定)
  @Prop()
  branchName?: string

  // ステータス
  @Prop()
  status!: string

  // 氏名プレースホルダー
  @Prop()
  fullNamePlaceholder!: string

  // 塾名プレースホルダー（ユーザ権限がシステム管理者の場合のみ設定）
  @Prop()
  academyNamePlaceholder?: string

  // 教室名プレースホルダー(ユーザ権限がシステム管理者、塾管理者の場合のみ設定)
  @Prop()
  branchNamePlaceholder?: string

  // ステータスプレースホルダー
  @Prop()
  statusPlaceholder!: string

  // 学年変更時イベント
  @Prop()
  gradeChangeEvent!: Function

  // 氏名変更時のイベント
  @Prop()
  fullNameChangeEvent!: Function

  // 塾名変更時のイベント（ユーザ権限がシステム管理者の場合のみ設定）
  @Prop()
  academyNameChangeEvent?: Function

  // 教室名変更時のイベント(ユーザ権限がシステム管理者、塾管理者の場合のみ設定)
  @Prop()
  branchNameChangeEvent?: Function

  // ステータス変更時のイベント
  @Prop()
  statusChangeEvent!: Function

  // 検索イベント
  @Prop()
  searchEvent!: Function

  /*
   * 入力値ゲッター・セッター
   */
  // 学年
  get selectedGrade(): string {
    return this.gradeValue
  }
  set selectedGrade(value: string) {
    this.gradeChangeEvent(value)
  }

  // 氏名
  get fullNameValue(): string {
    return this.fullName
  }
  set fullNameValue(value: string) {
    this.fullNameChangeEvent(value)
  }
  // 塾名
  get academyNameValue(): string {
    return this.academyName || ''
  }
  set academyNameValue(value: string) {
    if (this.academyNameChangeEvent) {
      this.academyNameChangeEvent(value)
    }
  }
  // 教室名
  get branchNameValue(): string {
    return this.branchName || ''
  }
  set branchNameValue(value: string) {
    if (this.branchNameChangeEvent) {
      this.branchNameChangeEvent(value)
    }
  }
  // ステータス
  get statusValue(): string {
    return this.status
  }
  set statusValue(value: string) {
    this.statusChangeEvent(value)
  }

  // システム管理者であるか
  private get isAdmin(): boolean {
    return this.userRole === UserRoles.ADMIN
  }

  // 塾管理者であるか
  private get isAcademy(): boolean {
    return this.userRole === UserRoles.ACADEMY
  }
}
</script>

<style lang="stylus" scoped>
.search-student
  display flex

  &__action,
  &__action-input,
  &__action-input-large
    margin 7px 5px

  &__action-input
    width 137px

  &__action-input-large
    width 164px
</style>
